export enum OrderTypes {
    GET_ORDERS_LOADING = "GET_ORDERS_LOADING",
    GET_ORDERS_SUCCESS = "GET_ORDERS_SUCCESS",
    GET_ORDERS_FAILURE = "GET_ORDERS_FAILURE",
    GET_STEPS_LOADING = "GET_STEPS_LOADING",
    GET_STEPS_SUCCESS = "GET_STEPS_SUCCESS",
    GET_STEPS_FAILURE = "GET_STEPS_FAILURE",
    CLEAR_ORDERS_SUCCESS = "CLEAR_ORDERS_SUCCESS",
}
